import dayjs from 'dayjs'

import { frontmanZendeskApi, METHOD } from '@/utils/api'

import { ArticleItem, Pagination, ZendeskRequestParams } from './types'

export type GetSearchArticlesRequest = ZendeskRequestParams

// [DOC] : https://developer.zendesk.com/api-reference/help_center/help-center-api/search/#search-articles
// UPDATED : 2023-11-16
export interface SearchArticleItem extends ArticleItem {
  result_type?: string
  snippet?: string
}

export interface GetSearchArticlesResponse extends Pagination {
  results: SearchArticleItem[]
}

/** FAQ 검색 API(cache) */
// 헬프 센터 API 사용 시, 지역 코드를 필수로 전달
export const getSearchArticles = (query: GetSearchArticlesRequest) => {
  // 젠데스크 검색 API 버그로 인하여 임시로 timestamp 추가 (https://tmobi.atlassian.net/browse/TMAPWEB-3707)
  const timestamp = dayjs().format('YYYYMMDDHHmm')
  return frontmanZendeskApi<GetSearchArticlesResponse>({
    path: '/api/zendesk/help_center/articles/search',
    method: METHOD.GET,
    query: { locale: 'ko', timestamp, ...query },
    isProxy: true,
  })
}
